export default __webpack_public_path__ + "static/media/pdf.ebc3c2f3.svg";